import { render, staticRenderFns } from "./text_align.vue?vue&type=template&id=f7d8ee56&lang=pug&"
import script from "./text_align.vue?vue&type=script&lang=js&"
export * from "./text_align.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f7d8ee56', component.options)
    } else {
      api.reload('f7d8ee56', component.options)
    }
    module.hot.accept("./text_align.vue?vue&type=template&id=f7d8ee56&lang=pug&", function () {
      api.rerender('f7d8ee56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/typography/text_align.vue"
export default component.exports